module.exports = __webpack_public_path__ + "img/tract_booking.4c0958f3.svg";